<template>
  <div>
    <h3 class="header">Hello World</h3>
    <!--<question type="date" v-model="q" text="Eligibility for the Cape Town discount" placeholder="Testing Questions" tip="testing the tooltip!"></question>-->
    <!--<paypal :client="$paypal.props.client" amount="10" currency="USD" :items="[{'name':'Test Product','description':'This is a test product.','quantity':1,'price':'10','currency':'USD'}]"></paypal>-->
    <!--<paypal v-model="paypal" :products="products" @complete="Complete" @ready="Ready"></paypal>
    <input type="number" class="input" v-model="products[0].amount.value" />-->
    <mock-chart></mock-chart>

    <score-chart :chart-data="barData"></score-chart>
    <!--<question v-model="autoQ" @change="Example" is-admin></question>-->
    <!--<question v-model="autoQ2" @change="Example"></question>
    <question v-model="autoQ3" @change="Example" column></question>
    <question v-model="autoQ4" @change="Example" open-on-focus></question>
    <h1 class="title is-1">The quick brown fox jumps over the lazy dog.</h1>
    <h2 class="title is-2">The quick brown fox jumps over the lazy dog.</h2>
    <p style="font-size:25px">The quick brown fox jumps over the lazy dog.</p>
    <span style="font-size:25px">The quick brown fox jumps over the lazy dog.</span>-->
  </div>
</template>
<script>
  import scoreChart from '@/services/components/ScoreChart.vue';
  import mockChart from '@/services/components/ScoreChart-mock.vue';
  export default {
    components: {
      "score-chart": scoreChart,
      "mock-chart": mockChart
    },
    data: function () {
      return {
        barData: {
          labels: ['Q3 2019', 'Q1 2020', 'Q3 2020', 'Q1 2021', 'Q3 2021'],
          datasets: [
            {
              label: "Egypt",
              backgroundColor: '#f87979',
              borderColor: '#f87979',
              data: [91, 93, 22, 56, 95],
              lineTension: 0,
              fill: false
            },
            {
              label: "Spain",
              backgroundColor: '#a87979',
              borderColor: '#a87979',
              data: [93, 94, 20, 55, 90],
              lineTension: 0,
              fill: false
            },
            {
              label: "United States",
              backgroundColor: '#0000ff',
              borderColor: '#0000ff',
              data: [97, 96, 50, 57, 78],
              lineTension: 0,
              fill: false
            },
            {
              label: "Russia",
              backgroundColor: '#00ff00',
              borderColor: '#00ff00',
              data: [99, 98, 70, 60, 80],
              lineTension: 0,
              fill: false
            }
          ]
        },

        q: null,
        p: null,
        paypal: undefined,
        products: [{
          amount: {
            value: '0.01',
            currency_code: 'USD'
          }
        }],
        autoQ: {
          model: "This is test text that fills the answer field. The model/type combination must make sense.",
          text: "This is a basic text field implementation.",
          type: "textarea",
          placeholder: "Enter Text Here",
          tip: "Html link: <a href='https://google.com'>Google</a>"
        },
        autoQ2: {
          model: "Yes",
          text: "This is a basic radio field implementation <a href='http://google.com'>click here for more details</a>",
          type: "radio",
          options: [{ key: "Yes", tip: "The generic yes option." }, { key: "No", tip: "The generic no option." }, { key: "Maybe", tip: "The generic '<b>I can't make up my mind' option.</b>" }]
        },
        autoQ3: {
          //model: ["Answer A", "Answer B"],
          //model: [],
          text: "Select the checkboxes below. 'Answer D will be added reactively'",
          tip: "The output is an array of strings",
          type: "checkbox",
          //options: ["Answer A", "Answer B", "Answer C"]
          options: [{ name: "Answer A", tip: "Select this to have A as your choice." }, { name: "Answer B" }, { name: "Answer C" }],
          optionKey: "name",
          column: true
        },
        autoQ4: {
          //model: "Item2",
          text: "Try the autocomplete",
          tip: "Partial text works too.",
          type: "tags",
          options: ["Item1", "Item2", "Item3"]
        }
      }
    },
    watch: {
      q: {
        handler(n, o) {
          //console.log(n);
        },
        deep: true
      }
    },
    methods: {
      Complete(details) {
        //console.log("Completed: ", details);
        this.$http.post("api/payment", details);
      },
      Ready() {
        //console.log("Ready: ", this.paypal);
        //this.$http.get("api/payment");
      },
      Example(val) {
        //console.log("example", val);
      }
    },
    created() {
      //Add a new set of questions reactively
      //setTimeout(() => { this.autoQ3.options = ["Answer A", "Answer B", "Answer C", "Answer D"] }, 6000);
    },
    mounted() {
      //setTimeout(() => {
      //  this.barData = {
      //    labels: ['United States', 'Canada'],
      //    datasets: [
      //      {
      //        label: "2019",
      //        backgroundColor: '#f87979',
      //        data: [20, 55],
      //      },
      //      {
      //        label: "2018",
      //        backgroundColor: '#a87979',
      //        data: [35, 10]
      //      }
      //    ]
      //  }
      //}, 4000);
    }
  }
</script>
